import { Buttons, FlexContainer } from '@taxdown/piccolo-web';
import useTranslation from 'Hooks/useTranslation';
import { ValidationButton } from './types';
import * as Styled from './styles';

const ValidationButtons = ({
  value,
  onPrevScreen,
  onNextScreen,
}: ValidationButton): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Styled.ButtonsContainer>
      <FlexContainer justify="center" gap="dimension_32">
        <Buttons.Classic
          size="m"
          mode="secondary"
          onClick={onPrevScreen}
          testID="dgGoBackButton"
          label={t('Button.back')}
        />
        <Buttons.Classic
          size="m"
          mode="success"
          disabled={!value}
          testID="dgContinueButton"
          onClick={onNextScreen}
          label={t('Button.continue')}
        />
      </FlexContainer>
    </Styled.ButtonsContainer>
  );
};

export default ValidationButtons;
